(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  const elWrap = document.getElementById('floatcart');
  const elToggle = elWrap ? elWrap.querySelector('.floatcart__toggle') : null;
  const elPanel = document.getElementById('floatcart-panel');
  const elItems = document.getElementById('floatcart-items');
  const elClose = elPanel ? elPanel.querySelector('.floatcart__close') : null;

  const elCount = document.getElementById('floatcart-count');
  const elCountLabel = document.getElementById('floatcart-count-label');
  const elTotal = document.getElementById('floatcart-total');
  const elSubtotal = document.getElementById('floatcart-subtotal');
  const elEmptyHint = document.getElementById('floatcart-emptyhint');
  const elMetaStats = document.getElementById('floatcart-metastats');
  const elLabel = document.getElementById('floatcart-label');

  if (!elWrap || !elToggle || !elPanel || !elItems || !elClose || !elCount ||
      !elCountLabel || !elTotal || !elSubtotal || !elEmptyHint || !elMetaStats || !elLabel) return;

  let lastToken = null;
  let lastItemCount = null;

  const money = (cents, currency) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'CAD' }).format(value);
    } catch {
      return `$${value.toFixed(2)}`;
    }
  };

  const getCart = async () => {
    const res = await fetch(root + 'cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return await res.json();
  };

  const escapeHtml = (s) => String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const escapeAttr = (s) => escapeHtml(s).replace(/`/g, '&#096;');

  const renderCart = (cart) => {
    const count = Number(cart.item_count || 0);
    const currency = cart.currency || cart.presentment_currency || 'CAD';
    const isEmpty = count <= 0;

    elWrap.hidden = false;
    elWrap.classList.toggle('floatcart--empty', isEmpty);
    elLabel.hidden = isEmpty;
    elEmptyHint.style.display = isEmpty ? 'inline' : 'none';
    elMetaStats.style.display = isEmpty ? 'none' : 'inline-flex';
    elLabel.style.display = isEmpty ? 'none' : '';

    elCount.textContent = String(count);
    elCountLabel.textContent = count === 1 ? '1 item' : `${count} items`;
    elToggle.setAttribute('aria-label', isEmpty
      ? 'Start your order. Your cart is empty.'
      : `Open your order, ${count} ${count === 1 ? 'item' : 'items'}, ${money(cart.total_price, currency)} total.`);
    elTotal.textContent = money(cart.total_price, currency);
    elSubtotal.textContent = money(cart.total_price, currency);

    if (isEmpty) {
      elItems.innerHTML = `<div class="floatcart__emptymsg"><p>Your cart is empty.</p><a class="floatcart__menu-link" data-fc-menu href="${escapeAttr(root)}#24kMenu">Browse the menu</a></div>`;
    } else {
      const items = Array.isArray(cart.items) ? cart.items : [];
      elItems.innerHTML = items.map((item) => {
        const title = item.product_title || item.title || 'Item';
        const qty = item.quantity || 0;
        const linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
        const key = item.key;
        return `
          <div class="floatcart__item">
            <div>
              <div class="floatcart__title">${escapeHtml(title)}</div>
              <div class="floatcart__line">Qty: ${qty} • ${money(linePrice, currency)}</div>
            </div>
            <button class="floatcart__remove" type="button" data-fc-remove="${escapeAttr(key)}">Remove</button>
          </div>
        `;
      }).join('');
    }

    lastToken = cart.token || null;
    lastItemCount = count;
  };

  const refresh = async () => {
    try {
      const cart = await getCart();
      if (cart.token === lastToken && cart.item_count === lastItemCount) return;
      renderCart(cart);
    } catch {
      elWrap.hidden = false;
    }
  };

  const setPanelOpen = (open, returnFocus = false) => {
    elToggle.setAttribute('aria-expanded', String(open));
    elPanel.hidden = !open;
    if (returnFocus) elToggle.focus({ preventScroll: true });
  };

  elToggle.addEventListener('click', () => {
    setPanelOpen(elToggle.getAttribute('aria-expanded') !== 'true');
  });

  elClose.addEventListener('click', () => setPanelOpen(false, true));

  elPanel.addEventListener('click', (e) => {
    if (e.target.closest('[data-fc-menu]')) setPanelOpen(false);
  });

  document.addEventListener('click', (e) => {
    if (!elWrap.contains(e.target) && elToggle.getAttribute('aria-expanded') === 'true') {
      setPanelOpen(false);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && elToggle.getAttribute('aria-expanded') === 'true') {
      setPanelOpen(false, true);
    }
  });

  elItems.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-fc-remove]');
    if (!btn) return;
    const key = btn.getAttribute('data-fc-remove');
    btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!res.ok) throw new Error('Unable to update cart');
      await refresh();
    } catch {
      btn.disabled = false;
    }
  });

  const isCartWriteUrl = (url) => /\/cart\/(add|change|update|clear)(\.js|\.json)/i.test(url);

  if (window.fetch) {
    const nativeFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const input = args[0];
      const url = typeof input === 'string' ? input : (input && input.url) ? input.url : '';
      const res = await nativeFetch(...args);
      if (res && res.ok && isCartWriteUrl(url)) setTimeout(refresh, 120);
      return res;
    };
  }

  if (window.XMLHttpRequest) {
    const nativeOpen = XMLHttpRequest.prototype.open;
    const nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this.__fc_url = url;
      return nativeOpen.call(this, method, url, ...rest);
    };
    XMLHttpRequest.prototype.send = function(...args) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300 && isCartWriteUrl(this.__fc_url || '')) {
          setTimeout(refresh, 120);
        }
      });
      return nativeSend.call(this, ...args);
    };
  }

  refresh();
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh();
  });
})();
